"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var yup = _interopRequireWildcard(require("yup"));
var _reactI18next = require("react-i18next");
var _yup2 = require("@hookform/resolvers/yup");
var _reactHookForm = require("react-hook-form");
var _ui = require("../../../../../../ui");
var _validations = require("../../../../../../../validations");
var _fields = require("../../../../../../fields");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ModalHeader = (0, _styledComponents.default)(_ui.ModalHeader)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  z-index: 1;\n"])));
var ModalBody = (0, _styledComponents.default)(_ui.ModalBody)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 20px;\n"])));
var H5 = (0, _styledComponents.default)(_ui.H5)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 24px;\n"])));
var Small = (0, _styledComponents.default)(_ui.Small)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-bottom: 27px;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var schema = yup.object().shape({
  code: _validations.numericalValidation.length(6).required()
}).required();
var Component = function Component(_ref2) {
  var isOpen = _ref2.isOpen,
    toggle = _ref2.toggle,
    onSubmit = _ref2.onSubmit,
    submitLoading = _ref2.submitLoading;
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  var _useForm = (0, _reactHookForm.useForm)({
      resolver: (0, _yup2.yupResolver)(schema)
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control;
  return /*#__PURE__*/_react.default.createElement(_ui.Modal, {
    isOpen: isOpen,
    toggle: toggle
  }, /*#__PURE__*/_react.default.createElement(ModalHeader, {
    onClick: toggle
  }), /*#__PURE__*/_react.default.createElement(ModalBody, {
    className: "d-flex"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    className: "d-flex flex-column flex-grow-1",
    onSubmit: handleSubmit(onSubmit),
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(H5, null, t('disableAuthenticator.title')), /*#__PURE__*/_react.default.createElement(Small, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "libSettings:disableAuthenticator.description"
  }, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, null))), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, {
    className: "text-left"
  }, t('disableAuthenticator.label')), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: control,
    inputProps: {
      name: 'code',
      placeholder: t('your6DigitCode')
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.Button, {
    color: "secondary",
    loading: submitLoading,
    type: "submit",
    className: "mt-auto",
    wide: true
  }, t('disable2FA')))));
};
exports.Component = Component;